import React from 'react';

type BrandLogoVariant = 'transparent' | 'white';

interface BrandLogoProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
    variant?: BrandLogoVariant;
}

const logoSources: Record<BrandLogoVariant, string> = {
    transparent: '/qlario_logo_transparent.png',
    white: '/qlario_logo_white.png',
};

const BrandLogo: React.FC<BrandLogoProps> = ({variant = 'transparent', ...props}) => {
    return (
        <img
            src={logoSources[variant]}
            alt="Qlario"
            draggable={false}
            {...props}
        />
    );
};

export default BrandLogo;
